<template>
  <div id="sabrole">
    <el-card class="box-card">
      <div slot="header" class="clearfix newhead">
        <span>人员管理&nbsp;/&nbsp;食安办管理</span>
        <el-button type="success" style="float: right" @click="addpeop(1)"
          >添加</el-button
        >
      </div>
      <div style="display: flex; flex-wrap: wrap; align-items: center">
        <Week @childFn="parentFn"></Week>
        <el-input
          class="elinputs"
          v-model="userName"
          placeholder="姓名"
        ></el-input>
        <el-input
          class="elinputs"
          v-model="poper"
          placeholder="手机号"
        ></el-input>
        <!-- 考核状态 -->
        <el-select class="elinputs" v-model="examState" placeholder="考核状态">
          <el-option
            v-for="item in examStateList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select class="elinputs" v-model="stat" placeholder="启用状态">
          <el-option
            v-for="item in statList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="zctime"
          type="daterange"
          value-format="yyyy-MM-dd"
          @blur="time"
          range-separator="至"
          start-placeholder="注册开始日期"
          end-placeholder="注册结束日期"
        >
        </el-date-picker>
        <el-button
          style="margin: 10px"
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button style="margin-left: 0" type="info" @click="reset"
          >重置</el-button
        >
      </div>
      <div class="tit">
        <span
          >总计：<i style="color: #11A983; font-weight: 600">{{ listnum }}</i>
          条</span
        >
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData"
        id="exportTab"
        border
        stripe
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="80" :index="1">
        </el-table-column>
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <!-- <img :src="scope.healthPhoto" alt=""> -->
            <img
              v-if="scope.row.photo == ''"
              class="sfzimg"
              src="../../assets/img/user_logo.png"
              alt=""
            />
            <viewer v-else>
              <img class="sfzimg" :src="imgUrl + scope.row.photo" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="姓名" width="120">
        </el-table-column>
        <el-table-column prop="telMobile" label="手机号" sortable width="160">
        </el-table-column>
        <el-table-column min-width="260" label="管辖区域">
          <template slot-scope="scope">
            <p>
              {{ scope.row.city }} {{ scope.row.district }}
              {{ scope.row.town }} {{ scope.row.village }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="考核状态" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.examState == 2" style="color: #67c23a">已考核</p>
            <p class="boldfont" v-if="scope.row.examState == 1" style="color: #f56c6c">未考核</p>
          </template>
        </el-table-column>
        <el-table-column label="最高得分" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.maxFraction }}</p>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.state == 1" style="color: #67c23a">启用</p>
            <p
              class="boldfont"
              v-if="scope.row.state == 2"
              style="color: #f56c6c"
            >
              禁用
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="注册时间"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180"
        >
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="360">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(scope.row, 'sab:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              :class="scope.row.state == '1' ? 'f56' : 'c23'"
              @click="prohibit(1, scope.row, 'sab:prohibit')"
              ><i class="el-icon-remove-outline"></i
              ><span v-if="scope.row.state == 1">禁用</span
              ><span v-else>启用</span></el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="prohibit(2, scope.row, 'sab:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      :title="sabtit"
      :visible.sync="dialogFormVisible"
      class="myxx"
      width="60%"
      style=""
    >
      <div style="display: flex; justify-content: space-between">
        <div style="width: 70%" class="leftcont">
          <p>* 登录账号</p>
          <el-input
            placeholder="请输入登录账号（手机号）"
            v-model="details.telMobile"
            :disabled="edit == 2"
            clearable
          >
          </el-input>
          <p>* 登录密码</p>
          <el-input
            placeholder="请输入登录密码（6-18位）"
            v-model="details.password"
            clearable
          >
          </el-input>
          <p>* 姓名</p>
          <el-input
            placeholder="请输入食安办姓名"
            v-model="details.userName"
            clearable
          >
          </el-input>
          <p>身份证号码</p>
          <el-input
            placeholder="请输入身份证号码"
            v-model="details.idCard"
            clearable
          >
          </el-input>
          <p>性别</p>
          <!--<el-input
                    placeholder="请输入性别"
                    v-model="details.userSex"
                    clearable>
                    </el-input> -->
          <el-select
            v-model="details.userSex"
            placeholder="请选择性别"
            style="width: 100%"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <p>
            身份证号码到期时间
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox
              v-model="checked"
              @change="yjbtn"
              :disabled="edit == 2"
              >长期</el-checkbox
            >
          </p>
          <el-date-picker
            v-if="!checked"
            v-model="details.idCardValidity"
            :disabled="edit == 2"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            placeholder="请输入身份证号码到期时间"
          >
          </el-date-picker>
          <el-input v-if="checked" disabled placeholder="长期" clearable>
          </el-input>
          <p>
            * 所属地区<span
              v-if="edit == 2"
              style="
                color: red;
                margin-left: 16px;
                text-decoration: underline;
                cursor: pointer;
              "
              @click="xgqy"
              >修改区域</span
            >
          </p>
          <el-input
            disabled
            v-if="modify == 1"
            :placeholder="
              details.province +
              ' ' +
              details.city +
              ' ' +
              details.district +
              ' ' +
              details.town +
              ' ' +
              details.village
            "
            clearable
          >
          </el-input>
          <Week
            @childFn="addparentFn"
            :inputName="sabrole"
            v-if="modify == 2"
          ></Week>
        </div>
        <div style="width: 26%">
          <div class="upload1" style="margin-top: 20px">
            <el-upload
              class="avatar-uploader"
              :action="URL"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :data="newobj"
              name="multipartFile"
              :headers="newhead"
            >
              <img v-if="imgurl" :src="imgUrl + imgurl" class="avatar" />
              <p v-else class="loadimg">上传头像</p>
            </el-upload>
          </div>
          <div class="upload1" style="margin-top: 20px">
            <el-upload
              class="avatar-uploader"
              :action="URL"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
              :before-upload="beforeAvatarUpload"
              :data="newobj"
              name="multipartFile"
              :headers="newhead"
            >
              <img v-if="imgurl2" :src="imgUrl + imgurl2" class="avatar" />
              <p v-else class="loadimg">上传身份证正面照</p>
            </el-upload>
          </div>
          <div class="upload1" style="margin-top: 20px">
            <el-upload
              class="avatar-uploader"
              :action="URL"
              :show-file-list="false"
              :on-success="handleAvatarSuccess3"
              :before-upload="beforeAvatarUpload"
              :data="newobj"
              name="multipartFile"
              :headers="newhead"
            >
              <img v-if="imgurl3" :src="imgUrl + imgurl3" class="avatar" />
              <p v-else class="loadimg">上传身份证背面照</p>
            </el-upload>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button @click="quxiao">取 消</el-button>
        <el-button class="newbtn" @click="gxdata">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Xlsx from "@/components/Xlsx";
import Paging from "@/components/Paging";
export default {
  name: "sabrole",
  components: {
    Week,
    Xlsx,
    Paging,
  },
  data() {
    return {
      examState: "", //考核状态
      examStateList: [
        { value: 1, name: "未考核" },
        { value: 2, name: "已考核" },
      ],
      stat: "",
      statList: [
        { value: 1, name: "启用" },
        { value: 2, name: "禁用" },
      ],
      poper: "",
      userName: "",
      zctime: "",
      tableData: [],
      userdata: {},
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      details: {},
      pwd: "",
      listnum: 0,
      areaId: "",
      btn: [],
      imgurl: "",
      imgurl2: "",
      imgurl3: "",
      edit: "",
      newhead: {
        accessToken: JSON.parse(sessionStorage.getItem("userdata")).token,
      },
      modify: 2,
      formname: JSON.stringify({ name: "食安办人员表", hint: "sab:export" }),
      sabtit: "",
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      URL: `${this.$Public.URL}/api-r/upload/uploadImg`,
      options: [
        {
          value: "男",
          label: "男",
        },
        {
          value: "女",
          label: "女",
        },
      ],
      checked: false, //永久身份证号码
      newobj: { type: 1 },
      sabrole: "-4",
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.load();
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  methods: {
    yjbtn() {
      if (this.checked) {
        this.checked = false;
        this.details.idCardValidity = "";
      } else if (!this.checked) {
        this.checked = true;
        this.details.idCardValidity = "";
      }
    },
    xgqy() {
      if (this.modify == 1) {
        this.modify = 2;
      } else if (this.modify == 2) {
        this.modify = 1;
      }
    },
    handleAvatarSuccess(res, file) {
      this.imgurl = res.url;
      this.details.photo = res.url;
    },
    handleAvatarSuccess2(res, file) {
      this.imgurl2 = res.url;
      this.details.frontPhoto = res.url;
    },
    handleAvatarSuccess3(res, file) {
      this.imgurl3 = res.url;
      this.details.backPhoto = res.url;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load();
    },
    load() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        adminAreasId: userdata.areasId,
        areaId: this.areaId,
        startTime: this.zctime[0],
        endTime: this.zctime[1],
        state: this.stat,
        examState: this.examState,
        telMobile: this.poper,
        userName: this.userName,
        userType: -4,
      });
      this.$axios
        .post(`/api-r/user/getXgList`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          // console.log(res,'食安办')
          if (res.data.success) {
            this.fullscreenLoading = false;
            this.$set(this, "listnum", res.data.pageInfo.total);
            this.$set(this, "tableData", res.data.pageInfo.list);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    parentFn(i) {
      this.areaId = i.id;
    },
    addparentFn(i) {
      this.details.areaId = i.id;
    },
    // 查询
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.load();
    },
    quxiao() {
      this.dialogFormVisible = false;
    },
    gxdata() {
      this.details.userType = "-4";
      if (this.edit == 1) {
        if (this.details.telMobile == undefined || this.details.telMobile == '') {
          return this.$message.error("请输入登录账号");
        }
        if (this.$Public.checkPhone(this.details.telMobile) == false) {
          return this.$message.error("请输入正确的手机号");
        }
        if (this.details.password == undefined || this.details.password == '') {
          return this.$message.error("请输入登录密码");
        }
        if (this.$Public.isPwd(this.details.password) == false) {
          return this.$message.error("请输入6-18位登录密码");
        }
        if (this.details.idCard != undefined) {
          if (this.details.idCard != "") {
            if (this.$Public.isCardNo(this.details.idCard) == false) {
              return this.$message.error("请输入正确的身份证号码");
            }
          }
        }
        if (this.details.userName == undefined || this.details.userName == '') {
          return this.$message.error("请输入食安办姓名");
        }
        if (sessionStorage.getItem("sabStat") != 1) {
          return this.$message.error("请选择所属地区到街道");
        }
        if (this.checked) {
          this.details.idCardValidity = "2099-01-01";
        }
        this.$axios
          .post(`/api-r/user/addUser`, this.$qs.stringify(this.details), {
            headers: { accessToken: this.userdata.token },
          })
          .then((res) => {
            if (res.data.success == true) {
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.$router.push("/refresh");
            } else {
              alert(res.data.msg);
            }
          });
      } else {
        if (this.details.password != undefined) {
          if (this.details.password != "") {
            if (this.$Public.isPwd(this.details.password) == false) {
              return this.$message.error("请输入6-18位登录密码");
            }
          }
        }
        if (this.details.userName == undefined || this.details.userName == '') {
          return this.$message.error("请输入食安办姓名");
        }
        if (this.details.idCard != undefined) {
          if (this.details.idCard != "") {
            if (this.$Public.isCardNo(this.details.idCard) == false) {
              return this.$message.error("请输入正确的身份证号码");
            }
          }
        }
        if (sessionStorage.getItem("sabStat") != 1) {
          return this.$message.error("请选择所属地区到街道");
        }
        let data = this.$qs.stringify({
          userId: this.details.userId,
          password: this.details.password,
          userName: this.details.userName,
          idCard: this.details.idCard,
          userSex: this.details.userSex,
          areaId: this.details.areaId,
          telMobile: this.details.telMobile,
          photo: this.details.photo,
          frontPhoto: this.details.frontPhoto,
          backPhoto: this.details.backPhoto,
          userType: -4,
        });
        this.$axios
          .post(`/api-r/user/updateUser`, data, {
            headers: { accessToken: this.userdata.token },
          })
          .then((res) => {
            if (res.data.success == true) {
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.$router.push("/refresh");
            } else {
              alert(res.data.msg);
            }
          });
      }
    },
    sortChange1(a, b) {
      console.log(a, b);
    },
    handleEdit(row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message.error("抱歉，用户暂无该权限");
      }
      this.sabtit = "食安办管理/编辑";
      if (row.idCardValidity == "2099-01-01 00:00:00") {
        this.checked = true;
      } else {
        this.checked = false;
      }
      sessionStorage.setItem("sabStat", 1);
      this.dialogFormVisible = true;
      this.$set(this, "details", row);
      this.$set(this, "imgurl", row.photo);
      this.$set(this, "imgurl2", row.frontPhoto);
      this.$set(this, "imgurl3", row.backPhoto);
      this.$set(this, "edit", 2);
      this.modify = 1;
    },
    addpeop(i) {
      this.modify = 2;
      this.sabtit = "食安办管理/添加";
      sessionStorage.setItem("sabStat", 0);
      this.$set(this, "edit", 1);
      this.$set(this, "imgurl", "");
      this.$set(this, "imgurl2", "");
      this.$set(this, "imgurl3", "");
      this.$set(this, "checked", false);
      this.dialogFormVisible = true;
      this.details = {};
    },
    // 禁用用户
    prohibit(i, row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message.error("抱歉，用户暂无该权限");
      }
      if (i == 1) {
        this.$axios
          .post(
            `/api-r/user/prohibitUser/${row.userId}`,
            {},
            { headers: { accessToken: this.userdata.token } }
          )
          .then((res) => {
            if (res.data.success == true) {
              if (row.state == 1) {
                this.$message({
                  type: "success",
                  message: "禁用成功",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "启用成功",
                });
              }
              this.load();
            } else {
              alert(res.data.msg);
            }
          });
      } else if (i == 2) {
        this.$confirm("此操作将删除该管理, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .post(
                `/api-r/user/deleteUser/${row.userId}`,
                {},
                { headers: { accessToken: this.userdata.token } }
              )
              .then((res) => {
                if (res.data.success == true) {
                  this.$message({
                    type: "success",
                    message: res.data.msg,
                  });
                  this.load();
                } else {
                  alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            return;
          });
      }
    },
    reset() {
      this.$router.push("/refresh");
    },
  },
};
</script>
<style>
#sabrole .el-input__inner {
  margin: 10px 0;
}
#sabrole .el-pagination__sizes .el-input__inner {
  margin: 0;
}
/* #sabrole .el-select{margin: 0 8px;} */
#sabrole .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#sabrole .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
/* 暂无数据样式 */
#sabrole .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#sabrole .leftcont .jdjsad {
  flex-wrap: wrap;
}
#sabrole .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
.el-input.is-disabled .el-input__inner {
  background: none !important;
}
#sabrole .el-upload {
  width: 100%;
}
#sabrole .el-input__prefix > i {
  display: none;
}
</style>
<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  display: block;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
  align-items: center;
}
.sfzimg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.upimg {
  width: 100%;
  text-align: center;
  background-color: #dcdcdc;
  line-height: 30px;
}
.upload1 {
  border: 1px solid #d2d2d2;
  padding: 6px;
}
.leftcont p {
  margin-bottom: 6px;
}
.newhead {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.loadimg {
  text-align: center;
  background: #ccc;
  color: #fff;
  font-size: 12px;
  line-height: 28px;
}
.jdjsad .el-select {
  width: 44%;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.newbtn {
  background-color: #11A983;
  color: #fff;
}
</style>
